import { Component, Event, EventEmitter, h, Prop, Listen } from '@stencil/core';
import { TreeviewNodeType } from '../../models';

@Component({
  tag: 'uui-tree-select-checkbox',
  styleUrl: './uui-tree-select-checkbox.css',
  shadow: false,
  scoped: true
})
export class UuiTreeSelectCheckbox {
  @Prop({ mutable: true }) item: TreeviewNodeType = {} as TreeviewNodeType;
  @Prop({ mutable: true }) groupName?: string = '';
  @Prop() indeterminate: boolean;
  @Event({ bubbles: true, composed: true, eventName: 'itemToggle' })
  itemChecked: EventEmitter;

  @Listen('toggleChange')
  onItemsUpdated(event) {
    this.onItemSelectionChanged(event);
  }

  onItemSelectionChanged(event: any) {
    this.item.checked = event.target.checked;
    const checkboxChildrenElements = (event.target as HTMLElement).childNodes;
    checkboxChildrenElements.forEach(element => {
      if (element.nodeName === 'INPUT') {
        this.indeterminate = (element as HTMLInputElement).indeterminate;
      }
    });

    this.itemChecked.emit(this.item);
  }

  render() {
    return (
      <div class="tree-select-checkbox-container">
        <uui-checkbox
          id={this.item.id as any}
          checked={this.item.checked}
          name={this.item.label}
          value={this.item.value}
          disabled={this.item.disabled}
          indeterminate={this.item.checked ? false : this.indeterminate}
        >
          <div class="checkbox-label">
            <uui-tooltip
              text={this.item.label}
              position="bottom"
              //   variant="default"
            >
              <div class="ellipsis-text">{this.item.label}</div>
            </uui-tooltip>
          </div>
        </uui-checkbox>
      </div>
    );
  }
}
